import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createGatewaysActionsSlice, createGatewaysDataSlice } from './slices'
import type { GatewaysStore } from './types'

export const useGatewaysStore = create<GatewaysStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createGatewaysDataSlice(...args),
        ...createGatewaysActionsSlice(...args),
      }))
    ),
    {
      name: 'GatewaysStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
